// Pages

const WORKFLOWS_PAGE = 'WORKFLOWS_PAGE';
const ARTICLE_PAGE = 'ARTICLE_PAGE';

export { WORKFLOWS_PAGE, ARTICLE_PAGE };
